// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph_Paragraph__2rah-","Sent":"Paragraph_Sent__DNfuf","Received":"Paragraph_Received__37EiW"};